import RulesManager from '../components/rules-management/RulesManager'

/**
 * COMPONENT SPECIFICATION: Rules Page
 * 
 * PURPOSE: 
 * - Main page for BRD rules management
 * - Provides user-level access to pharmaceutical compliance rules
 * - Integrates with account-level BRD configuration
 * 
 * FEATURES:
 * - View and manage all user BRD rules
 * - Upload BRD documents to extract new rules
 * - Edit existing rules (description, severity, field mapping)
 * - Add custom compliance rules
 * - Enable/disable rules for campaigns
 * - Rules persist at user account level across all campaigns
 * 
 * NAVIGATION:
 * - Accessible via main navigation sidebar
 * - Also accessible from campaign builder "Manage Rules" button
 * 
 * DATA FLOW:
 * - Rules loaded from /api/user-data/brd-rules
 * - Changes saved immediately to user account
 * - Rules applied to all user campaigns automatically
 * 
 * INTEGRATION:
 * - Uses RulesManager component for all functionality
 * - Connected to BRD document processing pipeline
 * - Rules feed into Creative Matrix validation
 */

export default function Rules() {
  return (
    <div className="p-6">
      <RulesManager />
    </div>
  )
}